import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d8b65a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "namespace-admins-page"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "namespace-admins-page__title" }, "Администраторы", -1))
const _hoisted_3 = { class: "namespace-admins-page__content" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "namespace-admins-page__users-list" }
const _hoisted_6 = { class: "namespace-admins-page__user-item-left" }
const _hoisted_7 = { class: "namespace-admins-page__sign-name" }
const _hoisted_8 = { class: "namespace-admins-page__user-item-right" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "namespace-admins-page__checkbox-tooltip-content" }, " Может формировать очередность задач ", -1))

import { ref, computed, inject, ComputedRef, watch } from 'vue';
import { AdapterService } from './adapter';
import { SaveAdminsModel, UserModel } from './models';
import {
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
  TirPmIconView,
  TirPmNotificationModel,
  TirPmNotificationEventBus,
  TirPmModal,
  TirCheckbox,
  TirPmPopover,
  PopoverColorEnum,
  PopoverPositionEnum,
  TirPmTooltipElement,
} from 'tir-components';
import { TirPmSearchInput, TirPmSearchInputContentLine } from 'tir-pm-search-input';
import { CurrentUser, UserRoleEnum } from 'tir-pm-user-core';
import { TrashIcon } from 'tir-style-system/icons/outline';
import { onMounted } from 'vue';
import ShortProfile from '@/api/Main/dataSource/api/users/profile/i-service/models/ShortProfile';
import { useRouter } from 'vue-router';
import { DeleteNamespaceAdminModal } from './components';


export default /*#__PURE__*/_defineComponent({
  __name: 'namespace-admins-page',
  props: {
  /**ID неймспейса */
  namespaceId: {
    type: String,
    required: true,
  },
  /**ID проекта */
  projectId: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const route = useRouter();

const adapter = new AdapterService();

const checkRightsFormQueue = ref();
/**Ссылка на модальное окно удаления админа неймспейса */
const $deleteAdminModal = ref<InstanceType<typeof DeleteNamespaceAdminModal>>();

/**Владелец */
const isOwner = computed(() => !!CurrentUser.Roles.includes(UserRoleEnum.Owner));
/**Админ проекта */
const isAdminProject = inject('isAdminProject') as ComputedRef<boolean>;

const rightsFormQueue = ref();

/**Загузка */
const isLoading = ref(false);

/**Получить список админов неймспейса */
const getNamespaceAdmins = async () => {
  copiedEditData.value = (await adapter.getNamespaceAdmins(props.namespaceId)).Value;
  selectedAdminUsers.value = copiedEditData.value;
};

const onSuccessDelete = async () => {
  await getNamespaceAdmins();
  filteredUser();
};

const searchQueryUsers = ref<string>(null);

// Сохранить модалку редактирования
const saveModalEditEmployee = async (users: Array<UserModel>) => {
  try {
    const resp = await adapter.saveNamespaceAdmins(
      new SaveAdminsModel({
        NamespaceId: props.namespaceId,
        Admins: users.map((admin) => ({
          Id: admin.Id,
          CanCustomizeOrder: admin.CanCustomizeOrder,
        })),
      }),
    );
    if (resp.IsSuccess) {
      await getNamespaceAdmins();
      TirPmNotificationEventBus.emit(
        'add',
        new TirPmNotificationModel({
          title: 'Успешное редактирование',
          type: 'success',
          group: 'general',
          life: 5000,
          closable: true,
          callbackButton: () => {},
        }),
      );
    } else {
      TirPmNotificationEventBus.emit(
        'add',
        new TirPmNotificationModel({
          title: resp.ErrorMessage ?? 'Произошла ошибка',
          type: 'error',
          group: 'general',
          life: 5000,
          closable: true,
          callbackButton: () => {},
        }),
      );
    }
  } catch (err: any) {
    console.log(err, 'error new');
    TirPmNotificationEventBus.emit(
      'add',
      new TirPmNotificationModel({
        title: err.ErrorMessage,
        type: 'error',
        group: 'general',
        life: 5000,
        closable: true,
        callbackButton: () => {},
      }),
    );
  }
};

const copiedEditData = ref();

// Переменная для списка пользователей, чтобы назначить из него админом или участником для селекта
const UserList = ref<Array<UserModel>>([]);

const selectedAdminUsers = ref<Array<UserModel>>([]);
const copiComparedUserList = ref<Array<UserModel>>([]);

/**Сортировка админов по имени */
const sortAdmins = computed(() =>
  selectedAdminUsers.value.sort((a, b) => a.FirstName.localeCompare(b.FirstName)),
);

// Функция для фильтрации юзеров
const filteredUser = (selectedUserName?: UserModel & string) => {
  copiComparedUserList.value = UserList.value;
  copiComparedUserList.value = copiComparedUserList.value.filter(
    (x) => !selectedAdminUsers.value.find((y) => y.Id == x.Id),
  );
  copiComparedUserList.value.sort((a, b) => a.FirstName.localeCompare(b.FirstName));
  if (typeof selectedUserName == 'string' && selectedUserName.length) {
    copiComparedUserList.value = copiComparedUserList.value.filter((x) => {
      let compairedString = x?.FirstName + ' ' + x?.MiddleName + ' ' + x?.LastName;
      return compairedString.toLowerCase().includes(selectedUserName.toLowerCase());
    });
  }
};

// Функция для выбора юзера для селекта администраторы
const setAdminToProject = async (selectedUser: UserModel) => {
  if (selectedUser.IsProjectAdmin || selectedUser.IsNamespaceAdmin) return;

  await saveModalEditEmployee([...selectedAdminUsers.value, selectedUser]);
  filteredUser();
  searchQueryUsers.value = '';
};

const onMouseDown = (user: UserModel, event: MouseEvent) => {
  if (user.IsProjectAdmin || user.IsNamespaceAdmin) event.preventDefault();
};

/**
 * Обновить canCustomizeOrder у пользователя
 */
const updateCanCustomizeOrder = async (user: UserModel, canCustomizeOrder: boolean) => {
  const index = selectedAdminUsers.value.findIndex((_user) => _user.Id === user.Id);
  if (index === -1) return;

  const updateUsers = [...selectedAdminUsers.value];

  updateUsers[index] = new UserModel({
    ...user,
    CanCustomizeOrder: canCustomizeOrder,
  });

  await saveModalEditEmployee(updateUsers);
};

// Функция для удаления юзера для селекта администраторы
// const removeAdminForProject = () => {
//   if (adminToDelete.value === undefined) return;
//   selectedAdminUsers.value = selectedAdminUsers.value.filter((x) => x.Id !== adminToDelete.value);
//   filteredUser();
//   saveModalEditEmployee();
//   adminToDelete.value = undefined;
// };

const loadProjects = async () => {
  let resp = await adapter.getEmployees(props.projectId, props.namespaceId);

  UserList.value = resp.Value.map(
    (x) =>
      new UserModel({
        Id: x.Id,
        FirstName: x.FirstName,
        LastName: x.LastName,
        MiddleName: x.MiddleName,
        Photo: x.Photo,
        AvatarColor: x.AvatarColor,
        IsProjectAdmin: x.IsProjectAdmin,
        IsNamespaceAdmin: x.IsNamespaceAdmin,
      }),
  );
  copiComparedUserList.value = UserList.value;
  filteredUser();
};

onMounted(async () => {
  const result = await adapter.checkProjectAdmin(
    Number(route.currentRoute.value.params.projectId),
    CurrentUser.Id,
  );
  checkRightsFormQueue.value = (await result).Value;
});

watch(
  () => checkRightsFormQueue.value,
  () => {
    rightsFormQueue.value = checkRightsFormQueue.value.CanCustomizeOrder;
  },
);

onMounted(async () => {
  try {
    copiedEditData.value = (await adapter.getNamespaceAdmins(props.namespaceId)).Value;
    selectedAdminUsers.value = copiedEditData.value;
    await loadProjects();
  } catch {}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(DeleteNamespaceAdminModal), {
            ref_key: "$deleteAdminModal",
            ref: $deleteAdminModal,
            admins: selectedAdminUsers.value,
            "project-id": __props.projectId,
            "namespace-id": __props.namespaceId,
            onOnSuccessDelete: onSuccessDelete
          }, null, 8, ["admins", "project-id", "namespace-id"]),
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(TirPmSearchInput), {
              style: {"width":"100%"},
              label: "Администраторы",
              placeholder: "",
              isWithPopup: true,
              modelValue: searchQueryUsers.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQueryUsers).value = $event)),
              onInput: filteredUser,
              isDisabled: !isOwner.value && !_unref(isAdminProject)
            }, {
              content: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(copiComparedUserList.value, (user) => {
                  return (_openBlock(), _createBlock(_unref(TirPmSearchInputContentLine), {
                    "is-disabled": user.IsProjectAdmin,
                    key: user.Id,
                    onMousedown: ($event: any) => (onMouseDown(user, $event)),
                    onClick: _withModifiers(($event: any) => (setAdminToProject(user)), ["stop"])
                  }, {
                    leftSlot: _withCtx(() => [
                      _createVNode(_unref(TirPmIconView), {
                        size: 24,
                        isRounded: "",
                        isBordered: false,
                        colorCode: user.AvatarColor,
                        imageLoadUrl: user.Photo
                      }, {
                        mainSlot: _withCtx(() => [
                          _createTextVNode(_toDisplayString(user?.FirstName?.[0].toUpperCase()) + _toDisplayString(user?.LastName?.[0].toUpperCase()), 1)
                        ]),
                        _: 2
                      }, 1032, ["colorCode", "imageLoadUrl"])
                    ]),
                    rightSlot: _withCtx(() => []),
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(user.FirstName) + " " + _toDisplayString(user.MiddleName) + " " + _toDisplayString(user.LastName), 1),
                      (user.IsProjectAdmin)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, " (Администратор проекта)"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["is-disabled", "onMousedown", "onClick"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "isDisabled"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortAdmins.value, (adminUser) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "namespace-admins-page__user-item",
                key: adminUser.Id
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_unref(TirPmIconView), {
                    size: 48,
                    isRounded: "",
                    isBordered: false,
                    colorCode: adminUser.AvatarColor,
                    imageLoadUrl: adminUser.Photo
                  }, {
                    mainSlot: _withCtx(() => [
                      _createTextVNode(_toDisplayString(adminUser?.FirstName?.[0].toUpperCase()) + _toDisplayString(adminUser?.LastName?.[0].toUpperCase()), 1)
                    ]),
                    _: 2
                  }, 1032, ["colorCode", "imageLoadUrl"]),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(adminUser?.FirstName) + " " + _toDisplayString(adminUser?.MiddleName) + " " + _toDisplayString(adminUser?.LastName), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  (isOwner.value || _unref(isAdminProject))
                    ? (_openBlock(), _createBlock(_unref(TirPmButton), {
                        key: 0,
                        class: "namespace-admins-page__delete-button",
                        size: _unref(TirPmButtonSizeEnum).Small,
                        variant: _unref(TirPmButtonVariantEnum).LinkState,
                        onClick: ($event: any) => ($deleteAdminModal.value?.open(adminUser))
                      }, {
                        leftSlot: _withCtx(() => [
                          _createVNode(_unref(TrashIcon))
                        ]),
                        _: 2
                      }, 1032, ["size", "variant", "onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(TirPmTooltipElement), null, {
                    content: _withCtx(() => [
                      _hoisted_9
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(TirCheckbox), {
                        "is-disabled": !(isOwner.value || rightsFormQueue.value),
                        "model-value": adminUser.CanCustomizeOrder,
                        "onUpdate:modelValue": ($event: any) => (updateCanCustomizeOrder(adminUser, $event))
                      }, null, 8, ["is-disabled", "model-value", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})